import React from 'react';
import YatungButton from '@Src/_basic/components/YatungButton';
import { useTranslation } from 'react-i18next';

interface Props {
  onGoBackButtonClick: () => void;
  onSubmit: () => void;
}
export default function OrganizeManagementCreateSubmit(props: Props) {
  const { t: i18T } = useTranslation();
  const { onGoBackButtonClick, onSubmit } = props;
  return (
    <>
      <YatungButton
        text={i18T('AREAMANAGEMENT.CANCEL')}
        variant="contained"
        color="error"
        size={'large'}
        type={'button'}
        sx={{
          color: '#ffffff',
          fontSize: '20px',
          px: 2,
          py: 'auto',
        }}
        onClick={onGoBackButtonClick}
      />
      <YatungButton
        text={i18T('AREAMANAGEMENT.COMPLETE')}
        variant={'contained'}
        size={'large'}
        type={'submit'}
        onSubmit={onSubmit}
        sx={{
          color: '#ffffff',
          bgcolor: '#BB5E00',
          fontSize: '20px',
          px: 2,
          py: 'auto',
          '&.MuiButtonBase-root:hover': {
            bgcolor: '#BB5E00',
          },
        }}
      />
    </>
  );
}
